import { Component, OnInit, inject, ViewChild } from "@angular/core";
import { CoreCommonModule } from "@core/common.module";
import { ActivatedRoute, Router } from "@angular/router";
import { User } from "@core/models";
import { resolveReturnUrl } from "@core/helpers/return-url.helpers";
import { serverErrorMessage } from "@core/helpers";
import { AuthenticationService } from "@core/services/auth";
import { CoreConfigService } from "@core/services/config.service";
import { HelperFunctionsService } from "@core/services/helper-functions.service";
import { ToastrService } from "ngx-toastr";
import { SubscriptionService } from "@core/services/subscription.service";
import { SubscriptionDetails } from "@core/models/subscription";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { RegistrationHelpPageComponent } from "../registration-help-page/registration-help-page.component";
import { LoginAccountType, LoginFormComponent } from "./components/login-form/login-form";
import { TeacherForgotUsernameComponent } from "./components/forgot-username/teacher-forgot-username/teacher-forgot-username";
import { StudentResetPasswordComponent } from "./components/student-reset-password/student-reset-password";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password";
import { ForgotUsernameComponent } from "./components/forgot-username/forgot-username.component";
import { RegisterFormComponent } from "./components/register-form/register-form";
import { RegisterPopupComponent } from "./components/register-popup/register-popup.component";

@Component({
  standalone: true,
  imports: [
    CoreCommonModule,
    LoginFormComponent,
    TeacherForgotUsernameComponent,
    StudentResetPasswordComponent,
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    RegisterFormComponent,
    RegisterPopupComponent,
  ],
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent implements OnInit {

  public returnUrl: string | null;
  public feedback: any;
  public error: any = {};
  public showForms = false;
  public loading = false;
  public showRegisterMawingu = false;
  public login = true;
  public register = false;
  public reset = false;
  public showForgotUsername = false;
  public forgot = false;
  public forgotUsername = true;
  public currentUser: User;
  userNameText: string = "Username or Phone Number";
  userNamePlaceholder: string = "Username/Phone Number";
  hasSelectedSubjects!: boolean;
  public showTeacherForgotUsername = false;
  public phoneNumberReadonly: boolean = false;
  public forgotPhoneNumber: string = '';
  public satisfiedSchools = [
    "assets/img/Anjego-Friends-High-School.png",
    "assets/img/Asumbi-Girls-High-School.png",
    "assets/img/Barani-Secondary-School.png",
    "assets/img/Beth-Mugo-High-School.png",
    "assets/img/Bungoma-High-School.png",
    "assets/img/Buru-Buru-Girls-School.png",
    "assets/img/Butula-School.png",
  ];

  public responsiveOptions = [
    {
      breakpoint: "1024px",
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: "768px",
      numVisible: 2,
      numScroll: 2,
    },
    {
      breakpoint: "560px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  contestMemberId: number;
  userRoles = ["Student", "Teacher", "Parent"];
  userAccountTypeSelected = false;
  selectedRole: string | null = null;
  labelText = "School Based Username/ Phone number";
  placeholderText = "Enter Username/Phone Number";
  mawinguPhoneNumber: string;
  isMawinguRedirect: boolean = false;
  mawinguUrl: string = '';
  flagImageUrl: string = 'assets/images/pages/flag_of_Kenya.png';
  successTick: string = 'assets/img/tick.png'
 
  public showResetPassword = false;
  public checkedResetUsername: string = '';
  /** What `/check` calls a school learner; the one category the name challenge is written for. */
  private static readonly CATEGORY_STUDENT = "STUDENT";

  @ViewChild(LoginFormComponent) loginFormRef: LoginFormComponent;
  currentLoginUsername = "";
  loginUserChecked = false;
  prefillUsername = "";


  private _coreConfigService = inject(CoreConfigService);
  private _router = inject(Router);
  private _authenticationService = inject(AuthenticationService);
  private toastr = inject(ToastrService);
  private _helperFunctions = inject(HelperFunctionsService);
  private _activatedRoute = inject(ActivatedRoute);
  private _subscriptionService = inject(SubscriptionService);
  private modalService = inject(NgbModal);

  constructor() {
    this._authenticationService.configureLoginLayout();
    if (this._router.url == "/logout") {
      this.logout();
    }

    const mawinguPhoneNumber = this._activatedRoute.snapshot.queryParamMap.get("phoneNumber");

    this.currentUser = this._authenticationService.currentUserValue;

    if (this.currentUser && !mawinguPhoneNumber) {
      const returnUrl = resolveReturnUrl(this._activatedRoute.snapshot.queryParams["returnUrl"]);
      if (returnUrl) {
        this._router.navigateByUrl(returnUrl);
      } else {
        this._helperFunctions.navigateToUsersDashboard(this.currentUser);
      }
      return;
    }

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }
  ngOnInit(): void {
    const queryPhoneNumber = this._activatedRoute.snapshot.queryParamMap.get("phoneNumber");
    if (queryPhoneNumber) {
      sessionStorage.setItem("mawinguPhoneNumber", queryPhoneNumber);
    }
    this.mawinguPhoneNumber = queryPhoneNumber || sessionStorage.getItem("mawinguPhoneNumber");
    this.isMawinguRedirect = this.mawinguPhoneNumber ? true : false;
    if (this.isMawinguRedirect) {
      this.userRoles = ["Student", "Teacher"];
      // Only auto-login when this is a genuine redirect from Mawingu (phoneNumber in the URL).
      // If we're only here because we restored the value from sessionStorage after a logout,
      // show the Mawingu UI but let the user log in manually — don't SSO them back in.
      if (queryPhoneNumber) {
        this.loginMawinguUser(this.mawinguPhoneNumber);
      }
    }

    this.returnUrl = resolveReturnUrl(
      this._activatedRoute.snapshot.queryParams["returnUrl"],
    );

    // check if there is a memberid
    this.contestMemberId =
      this._activatedRoute.snapshot.queryParams.contestMemberId;
    /**
     * Check if current user is set. If true, call helper functions method, navigate to usersDashboard
     */
    this._authenticationService.currentUser.subscribe({
      next: (user: User) => {
        if (user && !this.isMawinguRedirect) {
          this.currentUser = user;
          if (this.returnUrl) {
            this._router.navigateByUrl(this.returnUrl);
          } else {
            this._helperFunctions.navigateToUsersDashboard(
              this.currentUser,
            );
          }
        }
      },
    });

    this.switchToSignUpForm();
    this._activatedRoute.queryParams.subscribe((params) => {
      if (params["username"]) {
        this.prefillUsername = params["username"];
        this.userAccountTypeSelected = true;
        this.selectedRole = "Student";
        this.switchLabels("Student");
      }
    });
  }

  setLoginAccountSelected(): void {
    if (this.selectedRole) {
      this.userAccountTypeSelected = true;
      if (this.isMawinguRedirect && this.selectedRole == "Student")
        this.switchForm("forgotUsername");
    }
  }

  switchUser(): void {
    if (this.selectedRole) {
      this.userAccountTypeSelected = false;
      this.showResetPassword = false;
      this.showTeacherForgotUsername = false;
      this.phoneNumberReadonly = false;
      this.error = null;
      this.loginFormRef?.reset();
    }
  }


  /** The username check found another kind of account: show its card, keeping what was entered. */
  onAccountTypeDetected(type: LoginAccountType): void {
    this.applyRoleLabels(type);
  }

  switchLabels(type: string) {
    this.applyRoleLabels(type);
    this.error = null;
    this.login = true;
    this.forgot = false;
    this.showForgotUsername = false;
    this.loginFormRef?.reset();
  }

  private applyRoleLabels(type: string): void {
    this.selectedRole = type;
    if (type == "Student") {
      this.userNameText = this.labelText;
      this.userNamePlaceholder = this.placeholderText;
      this.forgotUsername = true;
    }
    if (type == "Teacher") {
      this.userNameText = "Zeraki Analytics Username";
      this.userNamePlaceholder = "username@school";
      this.forgotUsername = false;
    }
    if (type == "Parent") {
      this.userNameText = "Phone Number";
      this.userNamePlaceholder = "0712345678";
      this.forgotUsername = false;
    }
  }


  /**
   * Logout method
   */
  logout() {
    this._authenticationService.logout();
    this._router.navigate(["login"]);
  }


  //Public Methods
  switchForm(form: string) {
    this.clearAlerts();
    this.login =
      this.forgot =
      this.forgotUsername =
      this.register =
      this.reset =
        false;
    if (form === "login") {
      this.login = true;
      this.showForgotUsername = false;
      this.phoneNumberReadonly = false;
    }
    if (form === "register") {
      this.register = true;
    }
    if (form === "forgot") {
      this.forgot = true;
    }
    if (form === "forgotUsername") {
      this.forgotUsername = true;
      this.showForgotUsername = true;
    }
    if (form === "reset") {
      this.reset = true;
    }
  }

    loginMawinguUser(mawinguPhoneNumber: string) {
    const payloadData = {
      mawinguAccount: mawinguPhoneNumber,
    };
    this._authenticationService.mawinguUserLogin(payloadData).subscribe(
      (usr) => {
        const isStudent = usr.role === 30 || usr.role === 31;
        if (isStudent) {
          this.getUserSubscriptionDates(usr);
          return;
        }
        this._helperFunctions.navigateToUsersDashboard(usr);
      },
      (err) => {
        // A Mawingu link signs in automatically. A 400 is a number with no account ("Mawingu Account
        // not found") — the visitor simply stays here to sign up or log in, so it is not an error.
        if(!(err.error?.code === 400)) {
          this._helperFunctions.showWarningToastr(
            serverErrorMessage(err, "Couldn't sign you in. Please try again.")
          );
        }
      }
    );
  }

  scrollToElement(targetDiv: HTMLElement): void {
    targetDiv.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
  loginUser(username: string, password: string) {
  const isSelfRegistered = /^[0-9 +]*$/.test(username);
  this._authenticationService
    .login(username, password, isSelfRegistered, this.contestMemberId)
    .subscribe(
      (usr) => {
        this.loading = false;
        const isStudent = usr.role === 30 || usr.role === 31;
        if (isStudent) {
          this.getUserSubscriptionDates(usr);
          return;
        }
        if (this.returnUrl) {
          this._router.navigate([this.returnUrl]);
        } else {
          this._helperFunctions.navigateToUsersDashboard(usr);
        }
      },
      (err) => {
        this.loading = false;
        this.feedback = "";
        // This page renders no inline error, so the reason goes in a toast.
        this._helperFunctions.showWarningToastr(
          serverErrorMessage(err, "Couldn't sign you in. Please try again.")
        );
      },
    );
}

  getUserSubscriptionDates(user: User) {
    this._subscriptionService.getUserSubscriptionDetails().subscribe(
      (res: SubscriptionDetails) => {
        this.hasSelectedSubjects = res.subjectsSelected === true;
        if (!this.hasSelectedSubjects) {
          this._router.navigate(["/onboarding"]);
          return;
        }

        if (this.returnUrl) {
          this._router.navigate([this.returnUrl]);
        } else {
          this._helperFunctions.navigateToUsersDashboard(user);
        }
      },
      (err: any) => {
        console.error(err.error.message);
      },
    );
  }

  clearAlerts() {
    this.error = {};
    this.feedback = null;
  }

  changeUser(formName: string) {
    if (formName === "login") this.switchForm(formName);
    this.clearAlerts();
    this.phoneNumberReadonly = false;
    this.loginFormRef?.reset();
}

  backToLoginFromReset(): void {
    this.showResetPassword = false;
  }

  redirectToMainWebsite(): void {
    window.location.href = "https://www.zeraki.app/zeraki-learning";
  }

  switchToSignUpForm(): void {
    if (this._activatedRoute.snapshot.queryParams.toggleRegister === "true")
      this.switchForm("register");
  }

 /**
   * Routes a password reset by what the account IS, never by the role card that was clicked.
   *
   * The card is cosmetic — it sets labels and validators and is never sent anywhere — so selecting
   * "Student" and typing a teacher's username handed that teacher the school-student journey: a
   * full-name challenge instead of a code sent to their phone, against an endpoint that reverts a
   * password to an admission number a teacher does not have. A name is not a secret the way a phone
   * is, so the two journeys are not interchangeable and the weaker one must not be reachable by
   * mis-clicking a card.
   *
   * `/check` has already said what the account is before this link is even shown, so its category
   * decides. Within STUDENT the username still matters: a school account (`admno@schoolcode`) has an
   * admission number to revert to, while a self-registered student signs in with a phone and has
   * none — they belong on the code journey with everyone else.
   *
   * An account whose category we cannot read falls to the code journey, which asks for a phone and
   * says so when there is none. That is the safe direction to fail: the name challenge is the weaker
   * proof of identity and is never offered to an account we could not identify.
   */
 onLoginFormForgotPassword(event: {
  username: string;
  userPhoneNumber: string;
  userCategory: string;
}): void {
  const isPhone = /^\d{10}$/.test(event.username);

  const isSchoolStudent =
    event.userCategory === LandingPageComponent.CATEGORY_STUDENT && !isPhone;

  if (!isSchoolStudent) {
    if (!isPhone && !event.userPhoneNumber) {
      this.toastr.warning(
        "No phone number is registered on this account. Please contact customer care to reset your password.",
        "Unable to reset password",
        { timeOut: 6000, toastClass: "toast ngx-toastr", closeButton: true }
      );
      return;
    }
    this.switchForm('forgot');
    this.clearAlerts();
    this.error = {};
    this.phoneNumberReadonly = true;
    this.forgotPhoneNumber = isPhone
      ? (event.username.startsWith('0') ? event.username.slice(1) : event.username)
      : event.userPhoneNumber.replace(/^\+?254/, '');
  } else {
    this.showResetPassword = true;
    this.checkedResetUsername = event.username;
  }
}
onForgotPasswordComplete(username: string): void {
  this.forgot = false;
  this.login = true;
  this.feedback = null;
  this.loginFormRef?.prefillAfterPasswordReset(username);
}
  showTeacherForgotUsernameForm() {
    this.showTeacherForgotUsername = true;
  }

  get loginClasses() {
    return {
      "mx-md-2": this.register,
      "mx-md-3": !this.register,
      "mb-2": this.showForgotUsername || this.forgot,
      "mb-md-3": !this.showForgotUsername && !this.forgot,
    };
  }

  launchHelpModal(helpType: "login" | "registration" = "login"): void {
    const modalRef = this.modalService.open(RegistrationHelpPageComponent, {
      size: "sm",
      keyboard: false,
    });
    modalRef.componentInstance.helpType = helpType;
  }
  onRegistrationSuccess(event: { username: string; password: string }): void {
    this.loginUser(event.username, event.password);
  }

  goToRegisterMawingu(): void {
    this.showRegisterMawingu = true;
  }


  onRegisterMawinguClosed(): void {
    this.showRegisterMawingu = false;
  }

  onRegisterMawinguSuccess(): void {
    this.showRegisterMawingu = false;
  }
}
